const COMPANY_USER_TITLE_TR = "UYGUNLUK DEĞERLENDİRME KURULUŞU (UDK)";
const COMPANY_USER_TITLE_TR_LEGACY = "UYGUNLUK DEĞERLENDİRME KURULUŞU";
const COMPANY_USER_TITLE_EN = "CERTIFICATION BODY (CB)";

const normalizeCompanyUserTitle = (value: string) =>
  value.trim().toLocaleLowerCase("tr-TR");

const LOCALIZED_COMPANY_USER_TITLE_VARIANTS = new Set(
  [
    COMPANY_USER_TITLE_TR,
    COMPANY_USER_TITLE_TR_LEGACY,
    COMPANY_USER_TITLE_EN,
  ].map(normalizeCompanyUserTitle),
);

const getDefaultCompanyUserTitle = (isEnglish: boolean) =>
  isEnglish ? COMPANY_USER_TITLE_EN : COMPANY_USER_TITLE_TR;

type GetLocalizedCompanyUserTitleOptions = {
  fallbackToDefault?: boolean;
};

export const getLocalizedCompanyUserTitle = (
  value: string | null | undefined,
  isEnglish: boolean,
  options?: GetLocalizedCompanyUserTitleOptions,
) => {
  const normalizedValue = value?.trim();

  if (!normalizedValue || normalizedValue.toLowerCase() === "undefined") {
    return options?.fallbackToDefault
      ? getDefaultCompanyUserTitle(isEnglish)
      : "";
  }

  if (
    LOCALIZED_COMPANY_USER_TITLE_VARIANTS.has(
      normalizeCompanyUserTitle(normalizedValue),
    )
  ) {
    return getDefaultCompanyUserTitle(isEnglish);
  }

  return normalizedValue;
};
